import React, { Component } from 'react';
import { TabContent, TabPane,Table, Nav, NavItem, NavLink} from 'reactstrap';
import styles from './maintenance.module.css';
import tableStyles from './table.module.css';
import PencilIcon from 'Assets/icons/pen.svg';
import { FaTrash } from 'react-icons/fa';




export default class WorkSummaryMobileTabSystem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: '1'
        };
        this.toggle = this.toggle.bind(this);
        this.addCommentMobile = this.addCommentMobile.bind(this);
        this.editCommentMobile = this.editCommentMobile.bind(this);
        this.deleteCommentMobile = this.deleteCommentMobile.bind(this);
        
    }

    addCommentMobile(){this.props.onAction("add")}
    editCommentMobile(data){this.props.onAction(data)}
    deleteCommentMobile(data){this.props.onDelete(data)}

    toggle(tab) {
        if (this.state.activeTab !== tab) {
        this.setState({
            activeTab: tab
        });
        }
    }

    render() {
        let commentsRecords, partsRecords, laborRecords = null;
        let {activeTab}= this.state;
        let {workOrderSummaryData}= this.props;

        if(this.props.workOrderSummaryData !==null && !workOrderSummaryData.hasOwnProperty('statusText')){
            if(activeTab === '1'){

                commentsRecords = (workOrderSummaryData.workOrderComment.length !== 0) ?
                 workOrderSummaryData.workOrderComment.map((el, index) => (                 // Mobile Records returning all records from store only sorted but not paginating
                    <tr className={tableStyles.mobile_maintable_row} key={index}>
                      <td>
                        <table border="0" className={tableStyles.mobile_child_table}>
                          <tbody>
                            <tr><td>{"COMMENTS"}</td><td>{el.comments}</td></tr>
                            <tr><td>{"CREATED BY"}</td><td>{el.createdByUserName}</td></tr>
                            <tr><td>{"CREATED DATE"}</td><td>{new Date(el.createdOn).toDateString()}</td></tr>
                            {(workOrderSummaryData.createdByUserID === el.createdByUserID) ?
                             <tr><td></td><td><span>
                                  <img src={PencilIcon} alt="Trane Logo" className={styles.comments_edit_icon} onClick={() => { this.editCommentMobile(el) }} />
                                  <FaTrash className="Ensemble_Icon link_cursor" style={{ valign: 'bottom' }} onClick={() => { this.deleteCommentMobile(el.commentId) }} /></span> </td></tr>: null}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                //   )) : <div><p>No Entry</p></div>;
                )) : <tr><td>No Entry</td></tr>;
            }
            else if(activeTab === '2'){

                partsRecords = (workOrderSummaryData.workOrderPart.length !== 0) ?
                                    workOrderSummaryData.workOrderPart.map((el, index) => (                 // Mobile Records returning all records from store only sorted but not paginating
                                    <tr className={tableStyles.mobile_maintable_row} key={index}><td>
                                        <table border="0" className={tableStyles.mobile_child_table}>
                                            <tbody>
                                            <tr><td>{"PART NAME"}</td><td>{el.partName}</td></tr>
                                            <tr><td>{"PART #"}</td><td>{el.partNumber}</td></tr>
                                            <tr><td>{"QUANTITY"}</td><td>{el.quantity}</td></tr>
                                            </tbody>
                                        </table></td></tr>
                                    )) : <div><p>No Entry</p></div>;
            }
            else{

                laborRecords = (workOrderSummaryData.workOrderLabor.length !== 0) ?
                workOrderSummaryData.workOrderLabor.map((el, index) => (                 // Mobile Records returning all records from store only sorted but not paginating
                <tr className={tableStyles.mobile_maintable_row} key={index}>
                    <td><table border="0" className={tableStyles.mobile_child_table}>
                        <tbody>
                        <tr><td>{"NAME"}</td><td>{el.userName}</td></tr>
                        <tr><td>{"DATE OF SERVICE"}</td><td>{new Date(el.dateOfService).toDateString()}</td></tr>
                        <tr><td>{"REGULAR HOURS"}</td><td>{el.regularHour}</td></tr>
                        <tr><td>{"OVERTIME"}</td><td>{el.timeDuration}</td></tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                )) : <div><p>No Entry</p></div>;

            }
        }
        else{
            // console.log("display loader");
        }

        return (
            <div className={styles.whiteContainer}>
                     <Nav tabs>
                        <NavItem  className={styles.navItems}><NavLink  className={(this.state.activeTab === '1')? [styles.active_color_tab] :[styles.deactive_color_tab]} onClick={() => { this.toggle('1'); }}> Comments </NavLink>  </NavItem>
                        <NavItem  className={styles.navItems}><NavLink  className={(this.state.activeTab === '2')? [styles.active_color_tab] :[styles.deactive_color_tab]} onClick={() => { this.toggle('2'); }}> Parts </NavLink>  </NavItem>
                        <NavItem  className={styles.navItems}><NavLink  className={(this.state.activeTab === '3')? [styles.active_color_tab] :[styles.deactive_color_tab]} onClick={() => { this.toggle('3'); }}> Labor </NavLink>  </NavItem>
                     </Nav>
                    
                    <TabContent activeTab={this.state.activeTab} >
                            <TabPane tabId="1" className={styles.tabcontentcontainer}>
                                <div className={styles.addButtonContainer_mobile}>
                                    <button className="workorderedit-choosebtn" style={{ float: 'right', width: '125px', marginBottom: '4px' }} onClick={this.addCommentMobile}>{"ADD COMMENT"}</button>
                                </div>
                                <Table className={tableStyles.mobiletable}>
                                    <tbody>
                                        <tr><th>{"COMMENTS"}</th></tr>
                                        {commentsRecords} 
                                    </tbody>
                                </Table>
                             </TabPane> 

                            <TabPane tabId="2" className={styles.tabcontentcontainer}>
                               <Table className={tableStyles.mobiletable}>
                                    <tbody>
                                        <tr><th>{"PARTS"}</th></tr>
                                        {partsRecords} 
                                    </tbody>
                                </Table>
                            </TabPane>

                            <TabPane tabId="3" className={styles.tabcontentcontainer}>
                                <Table className={tableStyles.mobiletable}>
                                    <tbody>
                                        <tr><th>{"LABOR"}</th></tr>
                                        {laborRecords}
                                    </tbody>
                                </Table>
                            </TabPane>
                    </TabContent>
               
        </div>
        );
    }
}

